var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-form-textfield" },
    [
      _c(
        "validation-message",
        {
          attrs: {
            valid: _vm.valid,
            invalid: _vm.invalid,
            validationMessage: _vm.validationMessage
          }
        },
        [
          _c(
            "label",
            { staticClass: "c-form-textfield__label", attrs: { for: _vm.id } },
            [
              _vm.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value,
                        expression: "value"
                      }
                    ],
                    staticClass: "c-form-textfield__input",
                    attrs: {
                      id: _vm.id,
                      name: _vm.name,
                      placeholder: _vm.label,
                      required: _vm.required,
                      disabled: _vm.disabled,
                      readonly: _vm.readonly,
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.value)
                        ? _vm._i(_vm.value, null) > -1
                        : _vm.value
                    },
                    on: {
                      input: _vm.updateValue,
                      change: [
                        function($event) {
                          var $$a = _vm.value,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.value = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.value = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.value = $$c
                          }
                        },
                        _vm.changeValue
                      ],
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.submitForm($event)
                      }
                    }
                  })
                : _vm.type === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value,
                          expression: "value"
                        }
                      ],
                      staticClass: "c-form-textfield__input",
                      attrs: {
                        id: _vm.id,
                        name: _vm.name,
                        placeholder: _vm.label,
                        required: _vm.required,
                        disabled: _vm.disabled,
                        readonly: _vm.readonly,
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.value, null) },
                      on: {
                        input: _vm.updateValue,
                        change: [
                          function($event) {
                            _vm.value = null
                          },
                          _vm.changeValue
                        ],
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.submitForm($event)
                        }
                      }
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value,
                          expression: "value"
                        }
                      ],
                      staticClass: "c-form-textfield__input",
                      attrs: {
                        id: _vm.id,
                        name: _vm.name,
                        placeholder: _vm.label,
                        required: _vm.required,
                        disabled: _vm.disabled,
                        readonly: _vm.readonly,
                        type: _vm.type
                      },
                      domProps: { value: _vm.value },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.value = $event.target.value
                          },
                          _vm.updateValue
                        ],
                        change: _vm.changeValue,
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.submitForm($event)
                        }
                      }
                    }),
              _vm._v(" "),
              _c("span", { staticClass: "c-form-textfield__label-text" }, [
                _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.label) + "\n\t\t\t\t\t"),
                _vm.required
                  ? _c("span", { staticClass: "c-form-textfield__required" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.tooltip
        ? _c(
            "div",
            { staticClass: "c-tooltip" },
            [
              _c(
                "ToolTip",
                {
                  attrs: {
                    title: _vm.tooltipTitle,
                    isActive: _vm.isActiveTooltip
                  },
                  on: {
                    toggleTooltip: function(value) {
                      return _vm.$emit("toggleTooltip", value)
                    }
                  }
                },
                [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.tooltipMessage) }
                  }),
                  _vm._v(" "),
                  _vm.tooltipImageUrl
                    ? _c("img", {
                        staticClass: "test",
                        attrs: {
                          width: "84",
                          height: "117",
                          src: _vm.tooltipImageUrl
                        }
                      })
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23a5f978", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a5f978","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/forms/input/TextField.vue
// module id = 692
// module chunks = 0